import React from 'react';
import type { IconProps } from '../types';

export const Logout = (props: IconProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.83913 2.74628e-07H4.66667C5.03486 2.74628e-07 5.33333 0.298478 5.33333 0.666668C5.33333 1.03486 5.03486 1.33333 4.66667 1.33333H3.86667C3.29561 1.33333 2.90742 1.33385 2.60736 1.35837C2.31508 1.38225 2.16561 1.42553 2.06135 1.47866C1.81046 1.60649 1.60649 1.81046 1.47866 2.06135C1.42553 2.16561 1.38225 2.31508 1.35837 2.60736C1.33385 2.90742 1.33333 3.29561 1.33333 3.86667L1.33333 9.46667C1.33333 10.0377 1.33385 10.4259 1.35837 10.726C1.38225 11.0183 1.42553 11.1677 1.47866 11.272C1.60649 11.5229 1.81046 11.7268 2.06135 11.8547C2.16561 11.9078 2.31508 11.9511 2.60736 11.975C2.90742 11.9995 3.29561 12 3.86667 12H4.66667C5.03486 12 5.33333 12.2985 5.33333 12.6667C5.33333 13.0349 5.03486 13.3333 4.66667 13.3333H3.83912C3.30248 13.3333 2.85958 13.3333 2.49878 13.3039C2.12405 13.2733 1.77958 13.2075 1.45603 13.0427C0.95426 12.787 0.546312 12.3791 0.29065 11.8773C0.125789 11.5538 0.06008 11.2093 0.0294632 10.8346C-1.4777e-05 10.4738 -7.97189e-06 10.0309 2.74629e-07 9.49421V3.83914C-7.65412e-06 3.3025 -1.41958e-05 2.85958 0.0294637 2.49878C0.0600805 2.12405 0.12579 1.77958 0.290651 1.45603C0.546313 0.95426 0.954261 0.546312 1.45603 0.29065C1.77958 0.12579 2.12405 0.0600801 2.49878 0.0294633C2.85958 -1.4777e-05 3.30249 -7.97189e-06 3.83913 2.74628e-07Z"
      fill="#FCA5A5"
    />
    <path
      d="M8.86193 2.86193C9.12228 2.60158 9.54439 2.60158 9.80474 2.86193L13.1381 6.19526C13.3984 6.45561 13.3984 6.87772 13.1381 7.13807L9.80474 10.4714C9.54439 10.7318 9.12228 10.7318 8.86193 10.4714C8.60158 10.2111 8.60158 9.78894 8.86193 9.52859L11.0572 7.33333H4.66667C4.29848 7.33333 4 7.03486 4 6.66667C4 6.29848 4.29848 6 4.66667 6H11.0572L8.86193 3.80474C8.60158 3.54439 8.60158 3.12228 8.86193 2.86193Z"
      fill="#FCA5A5"
    />
  </svg>
);

export default Logout;
